import { render, staticRenderFns } from "./organization-sidebar-right-item.vue?vue&type=template&id=5e17682e&scoped=true"
import script from "./organization-sidebar-right-item.vue?vue&type=script&lang=js"
export * from "./organization-sidebar-right-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e17682e",
  null
  
)

export default component.exports